// extracted by mini-css-extract-plugin
export default {"keyTypesWrapper":"KeysTable_keyTypesWrapper__-Iwha"};